import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from "axios";
import { setBnText, setEnText, setEntity, setResult } from '../audio-recorder/asrSlice'
import Button from 'react-bootstrap/Button';
import { hideLoader, showLoader } from '../loader/loaderSlice';
import { Feedback } from '../feedback';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

const AsrSTT = () => {
    const dispatch = useDispatch();
    const bnText = useSelector((state) => state.asr.bnText);
    const appToken = useSelector((state) => state.auth.appToken);
    const [showToast, setShowToast] = useState(false);
    const [toastPosition, setToastPosition] = useState({ top: 0, left: 0 });

    const updateBnText = (input) => {
        dispatch(setBnText(input))
    }

    const copyText = (event) => {
        // Get the button's position
        const button = event.currentTarget;
        const rect = button.getBoundingClientRect();
        
        // Position toast just above the button
        setToastPosition({
            top: rect.top - 50,  // 10px above the button
            left: rect.left
        });

        navigator.clipboard.writeText(bnText)
            .then(() => {
                setShowToast(true);
                setTimeout(() => setShowToast(false), 3000);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    }

    const downloadWord = () => {
        // Create a text file with .doc extension
        const content = bnText;
        const blob = new Blob([content], { type: 'application/msword' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'transcript.doc';  // Changed to .doc extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    const buttonStyle = {
        marginRight: '10px',
        width: '80px',  // Fixed width for both buttons
        marginBottom: '10px'  // Add some bottom margin
    };

    return (
        <div className='asr mini-card'>
            <h4>ASR</h4>
            <div>
                <textarea
                    value={bnText}
                    rows="15" style={{"width": "100%"}}
                    onChange={(e) => updateBnText(e.target.value)} />
            </div>           
            <div>
                <Button
                    variant="outline-dark" 
                    size="sm" 
                    onClick={(e) => copyText(e)} 
                    style={buttonStyle}>
                    Copy
                </Button>
                <Button
                    variant="outline-dark"  size="sm" onClick={downloadWord} style={buttonStyle}>Download</Button>
                <Feedback 
                    type = {"asr"} />                
            </div>
            <ToastContainer
                style={{ 
                    position: 'fixed',
                    top: `${toastPosition.top}px`,
                    left: `${toastPosition.left}px`,
                    zIndex: 1000
                }}>
                <Toast 
                    show={showToast} 
                    onClose={() => setShowToast(false)}
                    delay={3000}
                    autohide>
                    <Toast.Body>Text copied to clipboard!</Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    );
};


export default AsrSTT;